import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _3a7eaeaf = () => interopDefault(import('../pages/countries.vue' /* webpackChunkName: "pages/countries" */))
const _947367d4 = () => interopDefault(import('../pages/help.vue' /* webpackChunkName: "pages/help" */))
const _0379cce4 = () => interopDefault(import('../pages/no-subscription.vue' /* webpackChunkName: "pages/no-subscription" */))
const _267508b1 = () => interopDefault(import('../pages/redirect.vue' /* webpackChunkName: "pages/redirect" */))
const _322ae582 = () => interopDefault(import('../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _efa5b166 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d3d3f98e = () => interopDefault(import('../pages/_countryCode.vue' /* webpackChunkName: "pages/_countryCode" */))
const _89510a08 = () => interopDefault(import('../pages/_countryCode/index.vue' /* webpackChunkName: "pages/_countryCode/index" */))
const _2e5a7b74 = () => interopDefault(import('../pages/_countryCode/_disciplineCode.vue' /* webpackChunkName: "pages/_countryCode/_disciplineCode" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/countries",
    component: _3a7eaeaf,
    name: "countries"
  }, {
    path: "/help",
    component: _947367d4,
    name: "help"
  }, {
    path: "/no-subscription",
    component: _0379cce4,
    name: "no-subscription"
  }, {
    path: "/redirect",
    component: _267508b1,
    name: "redirect"
  }, {
    path: "/terms",
    component: _322ae582,
    name: "terms"
  }, {
    path: "/",
    component: _efa5b166,
    name: "index"
  }, {
    path: "/:countryCode",
    component: _d3d3f98e,
    children: [{
      path: "",
      component: _89510a08,
      name: "countryCode"
    }, {
      path: ":disciplineCode",
      component: _2e5a7b74,
      name: "countryCode-disciplineCode"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
